import { Component, ComponentRef, OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AgendaService } from 'src/app/services/agenda/agenda.service';
import { ModalService } from 'src/app/services/modal/modal.service';
import { MultiprofessionalProtocolService } from 'src/app/services/multiprofessional-protocol/multiprofessional-protocol.service';
import { HeaderCommunicationService } from 'src/app/services/node/header-communication.service';
import { CreationProtocolePluriprofessionnel } from 'src/app/utils/interfaces/new/CreationProtocolePluriprofessionnel';
import { EventResource, SuperTypeEnum } from 'src/app/utils/interfaces/new/event-resource.interface';
import { Header } from 'src/app/utils/interfaces/new/header.interface';
import { ProtocolePluriprofessionnel } from 'src/app/utils/interfaces/new/ProtocolePluriprofessionnel';
import { ReunionPluriprofessionnellePersonnelSoignant } from 'src/app/utils/interfaces/new/ReunionPluriprofessionnellePersonnelSoignant';
import { CardIcon } from 'src/app/utils/interfaces/old/card-icon-interface';
import * as moment from 'moment';
import { Paginated } from 'src/app/utils/interfaces/new/paginated.interface';
import { CreationReunionPluriprofessionnellePersonnelSoignant, TypeEnum } from 'src/app/utils/interfaces/new/CreationReunionPluriprofessionnellePersonnelSoignant';
import { ModalSelectCaregiversComponent } from 'src/app/fragments/modal-select-caregivers/modal-select-caregivers.component';
import { ModalPatientsByAntecedentsComponent } from 'src/app/fragments/modal-patients-by-antecedents/modal-patients-by-antecedents.component';
import { ResultatPatient } from 'src/app/utils/interfaces/new/resultat-patient.interface';
import { PatientService } from 'src/app/services/patient/patient.service';
import { ModalPrintProtocolComponent, PrintReturn } from './modal-print-protocol/modal-print-protocol.component';
import { CreationProtocolePluriprofessionnelPatient } from 'src/app/utils/interfaces/new/CreationProtocolePluriprofessionnelPatient';
import { ProtocolePluriprofessionnelPatient } from 'src/app/utils/interfaces/new/ProtocolePluriprofessionnelPatient';
import { DocumentReturn, ModalSelectFileComponent } from './modal-select-file/modal-select-file.component';
import { DocumentService } from 'src/app/services/document/document.service';
import { MultiprofessionalProtocolDocumentMetadata } from 'src/app/utils/interfaces/new/MultiprofessionalProtocolDocumentMetadata';
import { ConsultationService } from 'src/app/services/consultation/consultation.service';
import { CourriersService } from 'src/app/services/consultation/courriers/courriers.service';
import { AUTEUR_AUTRE} from 'src/app/utils/interfaces/new/consultation.interface';
import { AskForDateComponent } from './ask-for-date/ask-for-date.component';
import { AskForAppointmentComponent, AppointmentData } from './ask-for-appointment/ask-for-appointment.component';
import { SourceTypeEnum } from 'src/app/utils/interfaces/new/ConsultationSource';
import { StringUtilsService } from 'src/app/services/string-utils/string-utils.service';
import { LoginService } from 'src/app/services/login/login.service';
import { FroalaEditorDirective } from 'angular-froala-wysiwyg';
import { environment } from 'src/environments/environment';
import { DisplayDocumentService } from 'src/app/services/display-document/display-document.service';
import { SnackbarService } from 'src/app/services/snackbar/snackbar.service';
import { HeaderFooterService } from 'src/app/services/header-footer/header-footer.service';
import { EventType } from 'src/app/utils/interfaces/new/event-type.interface';
import { SafeHtmlUtils } from 'src/app/utils/safe-html.util';
interface CaregiverTableDisplay {
  name: string;
  id: string;
  meta: ReunionPluriprofessionnellePersonnelSoignant;
}

interface DocumentTableDisplay {
  title: string;
  createdAt: string;
  author: string;
  id: string;
  meta: MultiprofessionalProtocolDocumentMetadata;
  fileMeta?: File;
}

interface PatientTableDisplay {
  name: string;
  dateEntry: Date;
  dateExit: Date;
  id: string;
  meta: ProtocolePluriprofessionnelPatient;
}

interface AddPatientIcon {
  title: string;
  icon: CardIcon;
}

interface SelectPatient {
  doSelect: boolean;
  patientId: string;
}

interface TempProtocolForm {
  protocolInfos: ProtocolePluriprofessionnel;
  protocolId?: string;
  caregivers?: Array<CaregiverTableDisplay>;
  patients?: Array<PatientTableDisplay>;
  documents?: Array<DocumentTableDisplay>;
  initialProtocol?: ProtocolePluriprofessionnel;
}

interface UpdatePatientDate {
  id: string;
  dateEntry: string;
  dateExit: string;
}

@Component({
  selector: 'app-edit-protocol',
  templateUrl: './edit-protocol.component.html',
  styleUrls: ['./edit-protocol.component.scss']
})
export class EditProtocolComponent implements OnInit, OnDestroy {

 editorContent: string = '';
  editorOptions: Object = {
    pluginsEnabled: [
      'table', 'fontSize', 'fontFamily', 
      'link', 'image', 'emoticons',
      'specialCharacters', 'embedly', 
       'fullscreen','selectAll','help',
      'paragraphFormat', 'paragraphStyle', 'align', 'lists', 'colors', 'lineHeight', 'quote'
    ],
    fontSize: ['6','8','10', '12', '14', '16', '18', '24', '36'],
    language: 'fr',
    toolbarButtons: [
      [ 'insertTable','insertLink', 'insertImage','embedly','emoticons', 'specialCharacters', ],
      [ 'bold', 'italic', 'underline', 'strikeThrough','textColor', 'backgroundColor','clearFormatting'],
      ['fontFamily', 'fontSize', 'quote', 'paragraphFormat', 'paragraphStyle'],
      ['alignLeft', 'alignCenter', 'alignRight', 'alignJustify', 'formatOL', 'formatUL', 'lineHeight', 'outdent', 'indent'],
      ['undo', 'redo', 'fullscreen', 'selectAll', 'help']
    ],
    height: 200,
    tabSpaces: 8,
    key: environment.froalaKey,
    attribution: false,
    width: '100%',
    events: {
        'image.beforeUpload': function (images) {
          // Convertir en base64 sinon on ne stocke que l'url locale de l'image
          const editor = this;
    
          if (images.length) {
            const reader = new FileReader();
    
            reader.onload = function (e) {
              editor.image.insert(e.target.result, null, null, editor.image.get());
            };
    
            reader.readAsDataURL(images[0]);
          }
    
          return false;
        }
      }
    };
  
  @ViewChild('froalaDrop') public froalaEditorDirective!:FroalaEditorDirective;
  editorInstance: any = null;
  initControls: any = null;

  public formGroup: FormGroup;
  private _resources: Array<EventResource> = [];
  public profilResources: Array<string> = [];
  public caregiversTable: Paginated<CaregiverTableDisplay>;
  public caregiversTableColumn = [
    { title: 'Nom', data: 'name' },
    { title: 'Supprimer', data: null }
  ];
  public patientsTable: Paginated<PatientTableDisplay>;
  public patientsTableColumn = [
    { title: 'Patient', data: 'name' },
    { title: 'Entrée', data: 'dateEntry', isEditable: true, editType: 'date' },
    { title: 'Sortie', data: 'dateExit', isEditable: true, editType: 'date' },
    { title: 'Supprimer', data: null }
  ];
  public documentsTable: Paginated<DocumentTableDisplay>;
  public documentsTableColumn = [
    { title: 'Titre', data: 'title' },
    { title: 'Date création', data: 'createdAt' },
    { title: 'Auteur', data: 'author' },
    { title: 'Supprimer', data: null }
  ];
  public searchPatientButton: AddPatientIcon = {
    title: 'Rechercher un patient',
    icon: {
      src: 'assets/icons/search.svg',
      color: 'var(--primary)',
      fill: 'var(--primary)'
    }
  };
  public patientToSeeButton: AddPatientIcon = {
    title: 'Patients à voir en réunion',
    icon: {
      src: 'assets/icons/eye.svg',
      color: 'var(--primary)',
      fill: 'var(--primary)'
    }
  };
  public listByAntecedentsButton: AddPatientIcon = {
    title: 'Liste par antécédent',
    icon: {
      src: 'assets/icons/document.svg',
      color: 'var(--primary)',
      fill: 'var(--primary)'
    }
  };
  public addToPatientConsultationsButton: AddPatientIcon = {
    title: 'Ajouter aux consultations',
    icon: {
      src: 'assets/icons/consultation.svg',
      color: 'var(--primary)',
      fill: 'var(--primary)'
    }
  };
  public selectedPatients: Array<PatientTableDisplay> = [];
  public protocolId: string;
  public initialProtocol: ProtocolePluriprofessionnel;
  private _titleFormChangeSub: Subscription;
  private _referentFormChangeSub: Subscription;
  private _createdAtFormChangeSub: Subscription;
  private _updatedAtFormChangeSub: Subscription;
  private _printReferentHeaderFormChangeSub: Subscription;
  private _protocolFormChangeSub: Subscription;
  private _protocolFirstTimeChange = true;
  public hasFormChange = false;
  public isEdit = false;
  private _defaultEventType: EventType;

  constructor(
    private _formBuilder: FormBuilder,
    private _activatedRoute: ActivatedRoute,
    private _send: HeaderCommunicationService,
    private _modalSrv: ModalService,
    private _viewContainerRef: ViewContainerRef,
    private _router: Router,
    private _mppSrv: MultiprofessionalProtocolService,
    private _agendaSrv: AgendaService,
    private _patientSrv: PatientService,
    private _documentSrv: DocumentService,
    private _consultationSrv: ConsultationService,
    private _strUtilsSrv: StringUtilsService,
    private _login: LoginService,
    private _courriersSrv: CourriersService,
    private _snackbar: SnackbarService,
    private _headFootSrv: HeaderFooterService
  ) {
    this.protocolId = this._activatedRoute.snapshot.params.protocolId;
    if (this.protocolId) {
      const head: Header = {
        backPage: 'protocoles',
        isBack: true,
        title: 'Éditer un protocole pluridisciplinaire',
        backCallBack: async () => this.cancelBackButton()
      };
      this._send.announceHeader(head);
    } else {
      const head: Header = {
        backPage: 'protocoles',
        isBack: true,
        title: 'Créer un protocole pluridisciplinaires',
        backCallBack: async () => this.cancelBackButton()
      };
      this._send.announceHeader(head);
    }
  }

  async ngOnInit(): Promise<void> {
    await this._initData();
  }

 /**
   * Initialisation de l'éditeur pour accéder aux méthodes de froala pour cibler l'éditeur, pour le drag and drop
   * @param initControls 
   */
  initialize(initControls: any) {
    this.initControls = initControls;
    this.initControls.initialize();

    setTimeout(() => {
      this.editorInstance = this.initControls.getEditor();

    });
  }

  ngOnDestroy(): void {
    if (this._titleFormChangeSub) {
      this._titleFormChangeSub.unsubscribe();
    }

    if (this._referentFormChangeSub) {
      this._referentFormChangeSub.unsubscribe();
    }
    if (this._createdAtFormChangeSub) {
      this._createdAtFormChangeSub.unsubscribe();
    }

    if (this._updatedAtFormChangeSub) {
      this._updatedAtFormChangeSub.unsubscribe();
    }
    if (this._printReferentHeaderFormChangeSub) {
      this._printReferentHeaderFormChangeSub.unsubscribe();
    }

    if (this._protocolFormChangeSub) {
      this._protocolFormChangeSub.unsubscribe();
    }
  }

  public async saveProtocol(): Promise<void> {
    if (!this.canValidProtocol()) {
      this._modalSrv.openAlert(this._viewContainerRef, 'Erreur de saisie', 'Un ou plusieurs champs obligatoires ne sont pas renseignés.\n\nVeuillez vérifier que les champs \'Titre\' et \'Référent\' ne soient pas vides.');
      return;
    }

    const loading = this._modalSrv.openLoading(this._viewContainerRef);

    try {
      await this._saveProtocol();
      this._snackbar.openSnackBarSuccess('Le protocole a été enregistré avec succès');
    } catch (e) {
      this._showAlert('Une erreur est survenue lors de l\'enregistrement de ce protocole');
      throw e;
    } finally {
      this._modalSrv.close(loading);
    }
  }

  public async validProtocol(): Promise<void> {
    const loading = this._modalSrv.openLoading(this._viewContainerRef);

    try {
      if (this.canValidProtocol()) {
        await this._saveProtocol();
        this._goToProtocolsTable();
      } else {
        this._modalSrv.openAlert(this._viewContainerRef, 'Erreur de saisie', 'Un ou plusieurs champs obligatoires ne sont pas renseignés.\n\nVeuillez vérifier que les champs \'Titre\' et \'Référent\' ne soient pas vides.');
      }
    } catch (e) {
      this._showAlert('Une erreur est survenue lors de la validation de ce protocole');
    } finally {
      this._modalSrv.close(loading);
    }
  }

  public addCaregiver(): void {
    const modal = this._modalSrv.openModal(this._viewContainerRef, ModalSelectCaregiversComponent);
    if (this.patientsTable && this.patientsTable.objects && this.patientsTable.objects.length > 0) {
      const patientsId: Array<string> = [];
      for (const p of this.patientsTable.objects) {
        patientsId.push(p.id);
      }
      modal.instance.patientsId = patientsId;
    }
    const sub = modal.instance.closeEmitter.subscribe((value?: Array<ReunionPluriprofessionnellePersonnelSoignant>) => {
      if (value) {
        for (const ps of value) {
          if ((this.caregiversTable
            && this.caregiversTable.objects
            && this.caregiversTable.objects.length > 0
            && !this.caregiversTable.objects.find((pp) => {
              return (ps.type !== TypeEnum.IntervenantExterne && pp.id === ps.id)
                || (ps.type === TypeEnum.IntervenantExterne && pp.name === ps.nom);
            }))
            || (!this.caregiversTable
              || !this.caregiversTable.objects
              || this.caregiversTable.objects.length === 0)) {
            this._addCaregiverToDisplayTable({
              id: ps.id,
              nom: ps.nom,
              type: ps.type
            });
          }
        }

        this.hasFormChange = true;
      }
      modal.destroy();
      sub.unsubscribe();
    });
  }

  public removeCaregiver(event: CaregiverTableDisplay): void {
    const modal = this._modalSrv.openModalConfirmation(this._viewContainerRef, 'Retirer soignant', 'Voulez-vous retirer ce soignant du protocole ?');
    const sub = modal.instance.closeEmitter.subscribe((res) => {
      if (res) {
        this.caregiversTable.objects.splice(this.caregiversTable.objects.findIndex(p => p.id === event.id), 1);
        this.hasFormChange = true;
      }
      sub.unsubscribe();
    });
  }

  public addDocument(): void {
    const enterDocumentInfos = (file: File): Promise<void> => {
      return new Promise<void>(async (resolve) => {
        const modal = this._modalSrv.openModal<ModalSelectFileComponent>(
          this._viewContainerRef, ModalSelectFileComponent) as ComponentRef<ModalSelectFileComponent>;
        modal.instance.documentName = file.name;
        const sub = modal.instance.closeEmitter.subscribe(async (rtd: DocumentReturn) => {
          if (rtd) {
            if (this.documentsTable && this.documentsTable.objects && this.documentsTable.objects.length > 0
              && this.documentsTable.objects.find(d => d.title === rtd.documentName)) {
              const alert = this._modalSrv.openAlert(this._viewContainerRef,
                'Erreur de saisie',
                'Un document avec le même titre existe déjà.\n\nVeuillez renommer ce fichier si vous voulez l\'ajouter');
              alert.onDestroy(async () => {
                await enterDocumentInfos({
                  name: rtd.documentName,
                  arrayBuffer: file.arrayBuffer,
                  lastModified: file.lastModified,
                  size: file.size,
                  slice: file.slice,
                  stream: file.stream,
                  text: file.text,
                  type: file.type
                });
              });
            } else {
              const currentProfilStr = localStorage.getItem('currentProfil');
              const currentProfil = JSON.parse(currentProfilStr);
              const currentUserStr = localStorage.getItem('currentUser');
              const currentUser = JSON.parse(currentUserStr);

              this._addDocumentToDisplayTable({
                auteurCreation: {
                  id: currentProfil.id,
                  nom: currentUser.nom.toLocaleUpperCase(),
                  prenom: this._strUtilsSrv.uppercaseFirstCharString(currentUser.prenom),
                  qualite: currentProfil.qualite
                },
                contentType: file.type,
                createdAt: new Date(),
                fileName: file.name,
                gedId: '',
                id: undefined,
                titre: rtd.documentName,
                type: undefined,
                version: 1,
                isPrivate: undefined,
                protocoleReferent: '',
                protocoleTitle: '',
                protocolDocumentAuthor: rtd.documentAuthor
              },
                file
              );
              this.hasFormChange = true;
            }
          }
          modal.destroy();
          sub.unsubscribe();
        });
        resolve();
      });
    };

    const input = document.createElement('input') as HTMLInputElement;
    input.type = 'file';
    input.click();
    input.onchange = async () => {
      const file = input.files[0];
      if (file) {
        await enterDocumentInfos(file);
      }
    };
  }

  public removeDocument(event: DocumentTableDisplay): void {
    const modal = this._modalSrv.openModalConfirmation(this._viewContainerRef, 'Retirer document', 'Voulez-vous retirer ce document du protocole ?');
    const sub = modal.instance.closeEmitter.subscribe((res) => {
      if (res) {
        this.documentsTable.objects.splice(this.documentsTable.objects.findIndex(p => p.id === event.id), 1);
        this.hasFormChange = true;
      }
      sub.unsubscribe();
    });
  }

  public async searchPatient(): Promise<void> {
    localStorage.setItem('protocolSaveTmp', JSON.stringify({
      protocolInfos: this._getProtocolFromForm(),
      caregivers: this.caregiversTable && this.caregiversTable.objects && this.caregiversTable.objects.length > 0
        ? this.caregiversTable.objects : undefined,
      patients: this.patientsTable && this.patientsTable.objects && this.patientsTable.objects.length > 0
        ? this.patientsTable.objects : undefined,
      documents: this.documentsTable && this.documentsTable.objects && this.documentsTable.objects.length > 0
        ? this.documentsTable.objects : undefined,
      protocolId: this.protocolId ? this.protocolId : undefined,
      initialProtocol: this.initialProtocol
    } as TempProtocolForm));

    await this._router.navigateByUrl(
      this._router.createUrlTree(
        ['/user/patient'], {
        queryParams: {
          navigateToMultiprofessionnalProtocolEditSearch: true,
          protocolId: this._activatedRoute.snapshot.params.protocolId
        }
      }
      )
    );
  }

  public openListByAntecedents(): void {
    const modal = this._modalSrv.openModal(this._viewContainerRef, ModalPatientsByAntecedentsComponent);

    try {
      const sub = modal.instance.closeEmitter.subscribe(async (selectedPatients: Array<ResultatPatient>) => {
        if (selectedPatients && selectedPatients.length > 0) {
          for (const p of selectedPatients) {
            if ((this.patientsTable
              && this.patientsTable.objects
              && this.patientsTable.objects.length > 0
              && !this.patientsTable.objects.find(pp => pp.id === p.id))
              || (!this.patientsTable
                || !this.patientsTable.objects
                || this.patientsTable.objects.length === 0)) {
              const patient = await this._patientSrv.findOnePatientInfos(p.id);
              this._addPatientToDisplayTable({
                dateDeNaissance: moment(patient.dateNaissance).toDate(),
                id: patient.id,
                nom: patient.nom,
                prenom: this._strUtilsSrv.uppercaseFirstCharString(patient.prenom),
                dateEntree: new Date()
              });
            }
          }

          this.hasFormChange = true;
        }
        modal.destroy();
        sub.unsubscribe();
      });
    } catch (e) {
      if (modal) {
        modal.destroy();
      }
      this._showAlert('Une erreur est survenue lors de la récupération des informations sur ce patient');
    }
  }

  public removePatient(patient: PatientTableDisplay): void {
    const modal = this._modalSrv.openModalConfirmation(this._viewContainerRef, 'Retirer patient', 'Voulez-vous retirer ce patient du protocole ?');
    const sub = modal.instance.closeEmitter.subscribe((res) => {
      if (res) {
        this.patientsTable.objects.splice(this.patientsTable.objects.findIndex(p => p.id === patient.id), 1);
        this.selectedPatients.splice(this.selectedPatients.findIndex(p => p.id === patient.id), 1);
        this.hasFormChange = true;
      }
      sub.unsubscribe();
    });
  }

  public addRemovePatient(event: PatientTableDisplay): void {
    if (!this.selectedPatients.includes(event)) {
      this._doSelectPatient({ doSelect: true, patientId: event.id });
      this.selectedPatients.push(event);
    } else {
      this._doSelectPatient({ doSelect: false, patientId: event.id });
      const index = this.selectedPatients.findIndex(e => e.id === event.id);
      this.selectedPatients.splice(index, 1);
    }
  }

  public async addProtocolToPatientsConsultations(): Promise<void> {
    const askForDate = async (): Promise<Date> => {
      return new Promise<Date>(async (resolve, reject) => {
        try {
          const modal = this._modalSrv.openModal<AskForDateComponent>(
            this._viewContainerRef, AskForDateComponent
          ) as ComponentRef<AskForDateComponent>;
          const sub = modal.instance.closeEmitter.subscribe((date?: Date) => {
            sub.unsubscribe();
            modal.destroy();
            resolve(date ? date : undefined);
          });
        } catch (e) {
          reject(e);
        }
      });
    };

    const date = this.initialProtocol && this.initialProtocol.consultationDate ? this.initialProtocol.consultationDate : await askForDate();

    const loading = this._modalSrv.openLoading(this._viewContainerRef);
    try {
      if (date) {
        for (const p of this.selectedPatients) {
          if (!p.meta.consultationId) {
            const currentProfil = this._login.getCurrentProfil();
            const consultationId = await this._consultationSrv.create({
              date,
              idPatient: p.id,
              titre: this.formGroup.get('title').value,
              consultationSource: {
                sourceId: this.initialProtocol.id,
                sourceType: SourceTypeEnum.MultiprofessionalProtocol
              },
              id: p.meta.consultationId,
              auteur: {
                id: currentProfil && currentProfil.id ? currentProfil.id : undefined,
                autre: !currentProfil || !currentProfil.id ? AUTEUR_AUTRE : undefined
              }
            });

            if (consultationId) {
              try {
                let courrierContent = '';
                
                if (date) {
                  courrierContent += `<p><strong>Date :</strong> ${moment(date).format('DD/MM/YYYY')}`;
                  if (moment(date).format('HH:mm') !== '00:00') {
                    courrierContent += ` à ${moment(date).format('HH:mm')}`;
                  }
                  courrierContent += `</p>`;
                }

                if (this.formGroup.get('protocol').value) {
                  courrierContent += `<h2>Protocole</h2>`;
                  courrierContent += `<div>${this.formGroup.get('protocol').value}</div>`;
                }
                await this._courriersSrv.create({
                  idConsultation: consultationId,
                  courrierText: courrierContent,
                  titre: this.formGroup.get('title').value || 'Protocole pluriprofessionnel',
                  isEnteteVide: false,
                  isPiedVide: false,
                  isDuplicata: false,
                  isImpressionPatient: false,
                  isVilleDate: true,
                  isNomPatient: false,
                  versionCourrier: 1
                }, consultationId);
              } catch (courrierError) {
                console.error('Erreur lors de la création du courrier:', courrierError);
              }
            }
          }
        }
        
        this._modalSrv.openAlert(this._viewContainerRef, 'Compte-rendu ajouté', 'Le compte-rendu du protocole a bien été ajouté aux consultations des patients sélectionnés');
      }
    } catch (e) {
      this._showAlert('Une erreur est survenue lors de la création de consultations pour le(s) patient(s) sélectionné(s)');
    } finally {
      this._modalSrv.close(loading);
    }
  }

  public printProtocol(): void {
    const modal = this._modalSrv.openModal(this._viewContainerRef, ModalPrintProtocolComponent);
    modal.instance.printReferentHeader = this.formGroup.get('printReferentHeader').value;
    const sub = modal.instance.closeEmitter.subscribe(async (printOptions: PrintReturn) => {
      this.formGroup.get('printReferentHeader').patchValue(printOptions.printOptions.printReferentHeader);
      if (printOptions.doPrint) {
        let doctorId = null;
        if (this.formGroup.get('printReferentHeader').value) {
          const referentName = this.formGroup.get('referent').value;
          const referentResource = this._resources.find(r => r.nom === referentName);
          if (referentResource) {
            doctorId = referentResource.id;
          }
        }
        const title = SafeHtmlUtils.escapeHtml(this.formGroup.get('title').value || 'Protocole Pluriprofessionnel');
        const referent = SafeHtmlUtils.escapeHtml(this.formGroup.get('referent').value || '');
        const date = SafeHtmlUtils.escapeHtml(this.formGroup.get('createdAt').value || '');
        // Le contenu du protocole est du HTML riche (Quill) → DOMPurify
        const protocolContent = SafeHtmlUtils.sanitizeHtmlString(this.formGroup.get('protocol').value || '');
        
        // Construction du contenu structuré
        let fullContent = `
          <div style="margin-bottom: 20px; font-family: Arial, sans-serif;">
            <h2 style="text-align: center; color: #333; margin-bottom: 20px;">Protocole Pluriprofessionnel</h2>
            <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px;">
              <tr>
                <td style="padding: 5px; font-weight: bold; width: 30%;">Titre du protocole :</td>
                <td style="padding: 5px;">${title}</td>
              </tr>
              ${referent ? `<tr><td style="padding: 5px; font-weight: bold;">Référent :</td><td style="padding: 5px;">${referent}</td></tr>` : ''}
              ${date ? `<tr><td style="padding: 5px; font-weight: bold;">Date de création :</td><td style="padding: 5px;">${date}</td></tr>` : ''}
            </table>
            <hr style="border: 0; border-top: 1px solid #ccc; margin: 20px 0;">
          </div>
        `;
        fullContent += protocolContent;
        
        try {
          await this._printProtocolDirect(fullContent, doctorId);
        } catch (e) {
          console.error('Erreur lors de l\'impression', e);
          this._modalSrv.openAlert(this._viewContainerRef, 'Erreur', 'Impossible d\'imprimer le document.');
        }
      }
      modal.destroy();
      sub.unsubscribe();
    });
  }

   private async _printProtocolDirect(content: string, doctorId: string | null): Promise<void> {
    let header = '';
    let headerHeight = 0;
    const printHeader = this.formGroup.get('printReferentHeader').value;
    
    if (printHeader && doctorId) {
      const rawHeader = await this._headFootSrv.findOneHeader(doctorId);
      if (rawHeader?.texte) {
        header = SafeHtmlUtils.sanitizeHtmlString(rawHeader.texte);
        headerHeight = rawHeader.headerHeight || 0;
      }
    }

    let footer = '';
    let footerHeight = 0;
    if (doctorId) {
      const rawFooter = await this._headFootSrv.findOneFooter(doctorId);
      if (rawFooter?.texte) {
        footer = SafeHtmlUtils.sanitizeHtmlString(rawFooter.texte);
        footerHeight = rawFooter.footerHeight || 0;
      }
    }

    const title = SafeHtmlUtils.escapeHtml(this.formGroup.get('title').value || 'Protocole Pluriprofessionnel');
    
    const customPrintStyle = `
      body {
       font-family: Arial, sans-serif;
      }
      
      table, th, td {
        border: 1px solid grey;
        border-collapse: collapse;
      }
      
      .entete {
        width: 100%;
        position: running(entete);
      }
      
      .entete img {
        max-width: 100%;
      }
      
      .ql-editor {
        padding: 0 !important;
      }
      
      .pied {
        width: 100%;
        position: running(pied);
      }
      
      .content h6,
      .content h5,
      .content h4 {
        margin: 0 !important;
        font-weight: normal !important;
      }
      
      .content p {
        margin-top: 0 !important;
        margin-bottom: 0 !important;
      }
      
      .content .ql-align-center {
        text-align: center !important;
      }
      
      .content .ql-align-right {
        text-align: right !important;
      }
      
      .content .ql-align-left {
        text-align: left !important;
      }
      
      .content p, li, h5 {
        font-size: 13px !important;
      }
      
      .content h4, ul {
        font-size: 16px !important;
      }
      
      .content h6 {
        font-size: 11px !important;
      }
      
      .content h3 {
        font-size: 18px !important;
      }
      
      .content h2 {
        font-size: 20px !important;
      }
      
      .content h1 {
        font-size: 24px !important;
      }
      
      .content {
        margin-top: 20px;
        height: auto;
        display: block;
      }
      
      @page {
        size: A4;
        margin-left: 10mm;
        margin-right: 10mm;
        margin-top: ${printHeader ? `${headerHeight + 10}px` : '2cm'} !important;
        margin-bottom: ${footerHeight}px !important;
        
        @top-center {
          padding-top: 20px 0px;
          content: element(entete);
        }
        
        @bottom-center {
          content: element(pied);
        }
      }
    `;

    const fullHtml = `
      <!DOCTYPE html>
      <html>
        <head>
          <meta charset="UTF-8">
          <title>${title}</title>
          <style>
            ${customPrintStyle}
          </style>
          <link href="https://cdnjs.cloudflare.com/ajax/libs/froala-editor/2.8.4/css/froala_editor.pkgd.min.css" rel="stylesheet" type="text/css">
          <link href="https://cdnjs.cloudflare.com/ajax/libs/froala-editor/2.8.4/css/froala_style.min.css" rel="stylesheet" type="text/css">
          <link href="https://cdnjs.cloudflare.com/ajax/libs/quill/1.3.7/quill.bubble.css" rel="stylesheet">
          <link href="https://cdnjs.cloudflare.com/ajax/libs/quill/1.3.7/quill.core.css" rel="stylesheet">
          <link href="https://cdnjs.cloudflare.com/ajax/libs/quill/1.3.7/quill.snow.css" rel="stylesheet">
          <script src="https://unpkg.com/pagedjs/dist/paged.polyfill.js"></script>
        </head>
        <body class="fr-view">
          ${printHeader ? `<div class="entete ql-editor">${header}</div>` : '<div class="entete"></div>'}
          <div class="pied ql-editor">${footer}</div>
          <div class="content">
            ${content}
          </div>
        </body>
      </html>
    `;

    const iframe = document.createElement('iframe');
    iframe.style.position = 'fixed';
    iframe.style.right = '0';
    iframe.style.bottom = '0';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = 'none';
    document.body.appendChild(iframe);

    const iframeDoc = iframe.contentWindow?.document;
    if (iframeDoc) {
      iframeDoc.open();
      iframeDoc.write(fullHtml);
      iframeDoc.close();
      iframe.onload = () => {
        setTimeout(() => {
          iframe.contentWindow?.print();
          // Nettoyer l'iframe après un délai
          setTimeout(() => {
            document.body.removeChild(iframe);
          }, 1000);
        }, 1500); // Délai plus long pour PagedJS
      };
    }
  }


  public canValidProtocol(): boolean {
    const protocol = this._getCreationProtocolFromForm();

    if (!protocol.titre || !protocol.referent) {
      return false;
    }

    return true;
  }

  public async deleteProtocol(): Promise<void> {
    const loading = this._modalSrv.openLoading(this._viewContainerRef);
    try {
      const modal = this._modalSrv.openModalConfirmation(this._viewContainerRef, 'Confirmation', 'Voulez-vous supprimer ce protocole ?');
      const sub = modal.instance.closeEmitter.subscribe(async (doDelete: boolean) => {
        if (doDelete) {
          if (this.protocolId) {
            await this._mppSrv.deleteMultiprofessionnalProtocols(this.protocolId);
          }
          this._goToProtocolsTable();
        }
        sub.unsubscribe();
      });
    } catch (e) {
      this._showAlert('Une erreur est survenue lors de la suppression de ce protocole');
    } finally {
      this._modalSrv.close(loading);
    }
  }

  public async addFollowUpAppointment(): Promise<void> {
    if (!this.protocolId) {
      this._snackbar.openSnackBarError('Le protocole doit être sauvegardé avant d\'ajouter un rendez-vous');
      return;
    }

    const modal = this._modalSrv.openModal<AskForAppointmentComponent>(
      this._viewContainerRef, AskForAppointmentComponent) as ComponentRef<AskForAppointmentComponent>;
    
    const sub = modal.instance.closeEmitter.subscribe(async (appointmentData: AppointmentData) => {
      if (appointmentData) {
        const loading = this._modalSrv.openLoading(this._viewContainerRef);
        try {
          if (!this._defaultEventType) {
            const eventTypes = await this._agendaSrv.getEventTypes();
            for (const e of eventTypes) {
              if (e.typeParDefaut) {
                this._defaultEventType = e;
                break;
              }
            }
          }

          const [startHour, startMinute] = appointmentData.startTime.split(':').map(Number);
          const [endHour, endMinute] = appointmentData.endTime.split(':').map(Number);
          
          const protocolTitle = this.formGroup.get('title')?.value || 'Protocole pluriprofessionnel';
          const description = `${protocolTitle} - Suivi`;

          const referentName = this.formGroup.get('referent')?.value;
          const referentResource = this._resources?.find(r => r.nom === referentName);
          const resources = [];
          if (referentResource) {
            resources.push({ id: referentResource.id, type: referentResource.superType });
          }

          // Rendez-vous unique
          const dateDebut = moment(appointmentData.date).hour(startHour).minute(startMinute).second(0).toDate();
          const dateFin = moment(appointmentData.date).hour(endHour).minute(endMinute).second(0).toDate();

          const eventToCreate: any = {
            dateDebut, dateFin,
            description: description,
            planifie: true,
            ressoursesId: resources,
            typeId: this._defaultEventType ? this._defaultEventType.id : undefined
          };

          await this._agendaSrv.createEvent(eventToCreate, true);
          
          this._snackbar.openSnackBarSuccess('Le rendez-vous de suivi a été créé');

        } catch (e) {
          console.error(e);
          this._snackbar.openSnackBarError('Une erreur est survenue lors de la création du rendez-vous');
        } finally {
          this._modalSrv.close(loading);
        }
      }
      modal.destroy();
      sub.unsubscribe();
    });
  }

  public updatePatientDates(event: Array<UpdatePatientDate>): void {
    if (this.patientsTable && this.patientsTable.objects && this.patientsTable.objects.length > 0) {
      for (const p of this.patientsTable.objects) {
        const e = event.find(ee => ee.id === p.id);
        if (e) {
          if (e.dateEntry) {
            const newEntryDate = moment(e.dateEntry, 'YYYY-MM-DD')
              .hour(moment(p.meta.dateEntree).hour())
              .minute(moment(p.meta.dateEntree).minute())
              .second(moment(p.meta.dateEntree).second())
              .toDate();

            p.meta.dateEntree = newEntryDate;
            p.dateEntry = newEntryDate;
          }

          if (e.dateExit) {
            const newExitDate = moment(e.dateExit, 'YYYY-MM-DD')
              .hour(moment(p.meta.dateSortie).hour())
              .minute(moment(p.meta.dateSortie).minute())
              .second(moment(p.meta.dateSortie).second())
              .toDate();

            p.meta.dateSortie = newExitDate;
            p.dateExit = newExitDate;
          }
        }

        this.hasFormChange = true;
      }
    }

    this.isEdit = !this.isEdit;
  }

  private async _initData(): Promise<void> {
    const modal = this._modalSrv.openLoading(this._viewContainerRef);

    try {
      this._resources = await this._getResources();

      for (const r of this._resources) {
        if (r.superType === SuperTypeEnum.Profil) {
          this.profilResources.push(r.nom);
        }
      }

      if (this.protocolId) {
        this.initialProtocol = await this._getProtocol(this.protocolId);
        this._initForm(this.initialProtocol);
      } else {
        this._initForm();
      }

      const doAddPatient = this._activatedRoute.snapshot.queryParamMap.get('doAddPatient');
      const patientToAddId = this._activatedRoute.snapshot.queryParamMap.get('patientId');
      if (doAddPatient && doAddPatient === 'true' && patientToAddId && patientToAddId !== '') {
        if ((this.patientsTable
          && this.patientsTable.objects
          && this.patientsTable.objects.length > 0
          && !this.patientsTable.objects.find(pp => pp.id === patientToAddId))
          || (!this.patientsTable
            || !this.patientsTable.objects
            || this.patientsTable.objects.length === 0)) {
          // On récupère le patient lié à l'ID
          const patient = await this._patientSrv.findOnePatientInfos(patientToAddId);
          if (patient) {
            // On ajoute le patient au tableau des patients
            this._addPatientToDisplayTable({
              dateDeNaissance: moment(patient.dateNaissance).toDate(),
              id: patient.id,
              nom: patient.nom,
              prenom: this._strUtilsSrv.uppercaseFirstCharString(patient.prenom),
              dateEntree: new Date()
            });
          }
        }

        this.hasFormChange = true;
      }
    } catch (e) {
      this._showAlert();
    } finally {
      this._modalSrv.close(modal);
    }
  }

  private _initForm(protocol?: ProtocolePluriprofessionnel): void {
    if (protocol && protocol.personnelSoignant && protocol.personnelSoignant.length > 0) {
      for (const p of protocol.personnelSoignant) {
        this._addCaregiverToDisplayTable(p);
      }
    }

    if (protocol && protocol.patients && protocol.patients.length > 0) {
      for (const p of protocol.patients) {
        this._addPatientToDisplayTable(p);
      }
    }

    if (protocol && protocol.documents && protocol.documents.length > 0) {
      for (const d of protocol.documents) {
        this._addDocumentToDisplayTable(d);
      }
    }

    if (localStorage.getItem('protocolSaveTmp')) {
      const protocolTmp = JSON.parse(localStorage.getItem('protocolSaveTmp')) as TempProtocolForm;
      if (protocolTmp) {
        protocol = protocolTmp.protocolInfos;
        this.caregiversTable = protocolTmp.caregivers && protocolTmp.caregivers.length > 0 ? {
          objects: protocolTmp.caregivers,
          page: 0, perpage: 0, total: 0
        } : undefined;
        this.patientsTable = protocolTmp.patients && protocolTmp.patients.length > 0 ? {
          objects: protocolTmp.patients,
          page: 0, perpage: 0, total: 0
        } : undefined;
        this.documentsTable = protocolTmp.documents && protocolTmp.documents.length > 0 ? {
          objects: protocolTmp.documents,
          page: 0, perpage: 0, total: 0
        } : undefined;
        this.protocolId = protocolTmp.protocolId;
        this.initialProtocol = protocolTmp.initialProtocol;
      }
      localStorage.removeItem('protocolSaveTmp');
    }

    const currentProfilStr = localStorage.getItem('currentProfil');
    const currentProfil = JSON.parse(currentProfilStr);
    const referent = protocol && protocol.referent
      ? protocol.referent.nom
      : this._resources.find(r => r.id === currentProfil.id).nom;

    this.formGroup = this._formBuilder.group({
      title: [protocol && protocol.titre ? protocol.titre : undefined, Validators.required],
      referent: [referent, Validators.required],
      createdAt: [protocol && protocol.dateCreation
        ? `Créé le ${moment(protocol.dateCreation).format('DD/MM/YYYY')} à ${moment(protocol.dateCreation).format('HH:mm')}`
        : undefined],
      updatedAt: [protocol && protocol.dateModification
        ? `Modifié le ${moment(protocol.dateModification).format('DD/MM/YYYY')} à ${moment(protocol.dateModification).format('HH:mm')}`
        : undefined],
      printReferentHeader: [protocol && protocol.impressionEnTeteReferent ? true : false],
      protocol: [protocol && protocol.protocole ? protocol.protocole : undefined]
    });

    this._titleFormChangeSub = this.formGroup.get('title').valueChanges.subscribe((v) => {
      this.hasFormChange = true;
    });

    this._referentFormChangeSub = this.formGroup.get('referent').valueChanges.subscribe((v) => {
      this.hasFormChange = true;
    });

    this._createdAtFormChangeSub = this.formGroup.get('createdAt').valueChanges.subscribe((v) => {
      this.hasFormChange = true;
    });

    this._updatedAtFormChangeSub = this.formGroup.get('updatedAt').valueChanges.subscribe((v) => {
      this.hasFormChange = true;
    });

    this._printReferentHeaderFormChangeSub = this.formGroup.get('printReferentHeader').valueChanges.subscribe((v) => {
      this.hasFormChange = true;
    });

    this._protocolFormChangeSub = this.formGroup.get('protocol').valueChanges.subscribe((v) => {
      if (this._protocolFirstTimeChange) {
        this._protocolFirstTimeChange = false;
      } else {
        this.hasFormChange = true;
      }
    });

  }

  private _addPatientToDisplayTable(patient: ProtocolePluriprofessionnelPatient): void {
    if (this.patientsTable) {
      this.patientsTable.objects.push({
        id: patient.id,
        meta: patient,
        name: `${patient.nom} ${this._strUtilsSrv.uppercaseFirstCharString(patient.prenom)} (${moment(patient.dateDeNaissance).format('DD/MM/YYYY')})`,
        dateEntry: patient.dateEntree,
        dateExit: patient.dateSortie
      });
    } else {
      this.patientsTable = {
        objects: [{
          id: patient.id,
          meta: patient,
          name: `${patient.nom} ${this._strUtilsSrv.uppercaseFirstCharString(patient.prenom)} (${moment(patient.dateDeNaissance).format('DD/MM/YYYY')})`,
          dateEntry: patient.dateEntree,
          dateExit: patient.dateSortie
        }],
        page: 0,
        perpage: 0,
        total: 0
      };
    }
  }

  private _addCaregiverToDisplayTable(caregiver: ReunionPluriprofessionnellePersonnelSoignant): void {
    if (this.caregiversTable) {
      this.caregiversTable.objects.push({
        id: caregiver.id,
        meta: caregiver,
        name: caregiver.nom
      });
    } else {
      this.caregiversTable = {
        objects: [{
          id: caregiver.id,
          meta: caregiver,
          name: caregiver.nom
        }],
        page: 0,
        perpage: 0,
        total: 0
      };
    }
  }

  private _addDocumentToDisplayTable(document: MultiprofessionalProtocolDocumentMetadata, file?: File): void {
    if (this.documentsTable) {
      this.documentsTable.objects.push({
        id: document.id,
        meta: document,
        author: document.protocolDocumentAuthor ? document.protocolDocumentAuthor : `${document.auteurCreation.qualite} ${document.auteurCreation.nom} ${this._strUtilsSrv.uppercaseFirstCharString(document.auteurCreation.prenom)}`,
        createdAt: '',
        title: document.titre,
        fileMeta: file
      });
    } else {
      this.documentsTable = {
        objects: [{
          id: document.id,
          meta: document,
          author: document.protocolDocumentAuthor ? document.protocolDocumentAuthor : `${document.auteurCreation.qualite} ${document.auteurCreation.nom} ${this._strUtilsSrv.uppercaseFirstCharString(document.auteurCreation.prenom)}`,
          createdAt: '',
          title: document.titre,
          fileMeta: file
        }],
        page: 0,
        perpage: 0,
        total: 0
      };
    }
  }

  private async cancelBackButton(): Promise<boolean> {
    return new Promise<boolean>(async (resolve) => {
      try {
        if (this.hasFormChange) {
          const propositions = [
            { label: 'Ne pas sauvegarder le protocole', value: 'dont_save_protocol' },
            { label: 'Sauvegarder le protocole', value: 'save_protocol' }
          ];

          const modal = this._modalSrv.openModalMultipleChoice(
            this._viewContainerRef,
            'Attention',
            'Vous vous apprétez à changer de page, ce protocole n\'est pas sauvegardé.',
            'Que voulez-vous faire ?',
            propositions
          );
          const modalSub = modal.instance.closeEmitter.subscribe(async (choice: string | null) => {
            if (choice === 'save_protocol') {
              await this.saveProtocol();
              resolve(true);
            } else if (choice === 'dont_save_protocol') {
              resolve(true);
            }

            modalSub.unsubscribe();
          });
        } else {
          resolve(true);
        }
      } catch (e) {
        resolve(false);
      }
    });
  }

  private async _saveProtocol(): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      try {
        const protocol = this._getCreationProtocolFromForm();
        if (this.protocolId) {
          await this._mppSrv.updateMultiprofessionnalProtocols(this.protocolId, protocol);
        } else {
          const protocolCreated = await this._mppSrv.createMultiprofessionnalProtocols(protocol);
          this.protocolId = protocolCreated.id;
        }

        if (this.hasFormChange && this.documentsTable) {
          const tableDocuments = this.documentsTable.objects;
          for (const d of tableDocuments) {
            if (!d.id && d.fileMeta) {
              const fileId = await this._documentSrv.uploadFile({
                content: await this._documentSrv.convertFileToBase64(d.fileMeta),
                fileName: d.fileMeta.name,
                mime: d.fileMeta.type
              });
              const profilStr = localStorage.getItem('currentProfil');
              const profil = JSON.parse(profilStr);
              await this._documentSrv.createProtocolDocument(
                this.protocolId, {
                authorId: profil.id,
                contentType: d.fileMeta.type,
                fileName: d.fileMeta.name,
                gedId: fileId,
                titre: d.title,
                typeId: 'b98d0840-13c5-44ef-a927-99610bb9174a',
                protocolDocumentAuthor: d.author,
                weight: d.fileMeta.size
              }
              );
            }
          }

          if (this.initialProtocol && this.initialProtocol.documents) {
            for (const d of this.initialProtocol.documents) {
              if (!tableDocuments.find(id => d.id === id.id)) {
                // Si le document du protocole initial n'est pas dans le tableau
                // Alors on le supprime
                await this._documentSrv.deleteDocument(d.id);
              }
            }
          }
        }

        resolve();
      } catch (e) {
        reject(e);
      }
    });
  }

  private _getCreationProtocolFromForm(): CreationProtocolePluriprofessionnel {
    const caregivers: Array<CreationReunionPluriprofessionnellePersonnelSoignant> = [];
    if (this.caregiversTable && this.caregiversTable.objects && this.caregiversTable.objects.length > 0) {
      for (const cg of this.caregiversTable.objects) {
        caregivers.push({
          id: cg.id ? cg.id : undefined,
          type: cg.meta.type,
          estPresent: cg.meta.estPresent,
          nom: cg.meta.nom
        });
      }
    }

    const patients: Array<CreationProtocolePluriprofessionnelPatient> = [];
    if (this.patientsTable && this.patientsTable.objects && this.patientsTable.objects.length > 0) {
      for (const p of this.patientsTable.objects) {
        patients.push({
          id: p.id,
          dateEntree: p.meta.dateEntree,
          dateSortie: p.meta.dateSortie
        });
      }
    }

    return {
      estValide: this.initialProtocol && this.initialProtocol.estValide
        ? true
        : false,
      impressionEnTeteReferent: this.formGroup.get('printReferentHeader') && this.formGroup.get('printReferentHeader').value
        ? true
        : false,
      patients,
      personnelSoignant: caregivers,
      protocole: this.formGroup.get('protocol') && this.formGroup.get('protocol').value
        ? this.formGroup.get('protocol').value
        : undefined,
      referent: this.formGroup.get('referent').value
        ? this._resources.find(r => r.nom === this.formGroup.get('referent').value).id
        : undefined,
      titre: this.formGroup.get('title') && this.formGroup.get('title').value
        ? this.formGroup.get('title').value
        : undefined,
    };
  }

  public cancelChanges(): void {
    if (this.hasFormChange) {
      const modal = this._modalSrv.openModalConfirmation(this._viewContainerRef, 'Protocole modifié', 'Si vous quittez, les modifications effectuées sur ce protocole seront effacées. Voulez-vous vraiment quitter ?');
      const sub = modal.instance.closeEmitter.subscribe((res) => {
        if (res) {
          this._goToProtocolsTable();
        }
        sub.unsubscribe();
      });
    }
  }

  private _getProtocolFromForm(): ProtocolePluriprofessionnel {
    const personnelSoignant: Array<ReunionPluriprofessionnellePersonnelSoignant> = [];
    if (this.caregiversTable && this.caregiversTable.objects && this.caregiversTable.objects.length > 0) {
      for (const cg of this.caregiversTable.objects) {
        personnelSoignant.push(cg.meta);
      }
    }

    const patients: Array<ProtocolePluriprofessionnelPatient> = [];
    if (this.patientsTable && this.patientsTable.objects && this.patientsTable.objects.length > 0) {
      for (const p of this.patientsTable.objects) {
        patients.push(p.meta);
      }
    }

    const documents: Array<MultiprofessionalProtocolDocumentMetadata> = [];
    if (this.documentsTable && this.documentsTable.objects && this.documentsTable.objects.length > 0) {
      for (const d of this.documentsTable.objects) {
        documents.push(d.meta);
      }
    }

    return {
      id: this.protocolId ? this.protocolId : undefined,
      dateCreation: this.initialProtocol ? this.initialProtocol.dateCreation : undefined,
      dateModification: this.initialProtocol && this.initialProtocol.dateModification ? this.initialProtocol.dateModification : undefined,
      documents,
      estValide: this.initialProtocol && this.initialProtocol.estValide ? true : false,
      impressionEnTeteReferent: this.formGroup.get('printReferentHeader') && this.formGroup.get('printReferentHeader').value
        ? this.formGroup.get('printReferentHeader').value
        : false,
      patients,
      personnelSoignant,
      protocole: this.formGroup.get('protocol') && this.formGroup.get('protocol').value ? this.formGroup.get('protocol').value : undefined,
      referent: this.formGroup.get('referent').value
        ? this._resources.find(r => r.nom === this.formGroup.get('referent').value)
        : undefined,
      titre: this.formGroup.get('title') && this.formGroup.get('title').value ? this.formGroup.get('title').value : ''
    };
  }

  private _goToProtocolsTable(): void {
    this._router.navigateByUrl('/user/protocoles');
  }

  private async _getResources(): Promise<Array<EventResource>> {
    return new Promise<Array<EventResource>>(async (resolve, reject) => {
      try {
        const resources = await this._agendaSrv.getResources();
        resolve(resources);
      } catch (e) {
        reject(e);
      }
    });
  }

  private async _getProtocol(protocolId: string): Promise<ProtocolePluriprofessionnel> {
    return new Promise<ProtocolePluriprofessionnel>(async (resolve, reject) => {
      try {
        const protocol = await this._mppSrv.getOneMultiprofessionnalProtocol(protocolId);
        resolve(protocol);
      } catch (e) {
        reject(e);
      }
    });
  }

  private _doSelectPatient(patient: SelectPatient): void {
    if (this.patientsTable && this.patientsTable.objects) {
      const index = this.patientsTable.objects.findIndex(p => p.id === patient.patientId);
      const patientDisplayTable = this.patientsTable.objects.find(p => p.id === patient.patientId);

      if (patient.doSelect) {
        Object.defineProperty(patientDisplayTable, 'rowColor', { configurable: true, value: 'var(--primary)' });
        Object.defineProperty(patientDisplayTable, 'textColor', { configurable: true, value: 'var(--white)' });
      } else {
        Object.defineProperty(patientDisplayTable, 'rowColor', { configurable: true, value: 'transparent' });
        Object.defineProperty(patientDisplayTable, 'textColor', { configurable: true, value: 'var(--black)' });
      }

      this.patientsTable.objects.splice(index, 1, patientDisplayTable);
    }
  }

  private _showAlert(msg?: string): void {
    msg = msg ? msg : 'Une erreur est survenue lors de la récupération des informations de cette page';

    this._modalSrv.openAlert(this._viewContainerRef, 'Erreur', msg);
  }

}
